import {handleActions} from 'redux-actions';

import {DISPLAY_ERROR, HIDE_ERROR} from '/redux/action/apiError.action';
import {withPayload} from '/util/reducer.util';

import displayApiError from './apiError/displayApiError';
import hideError from './apiError/hideError';

const initialState = {};

export default handleActions(
  {
    [DISPLAY_ERROR]: withPayload(displayApiError),
    [HIDE_ERROR]: withPayload(hideError),
  },
  initialState,
);
